<template>
  <div class="tw-text-center tw-mb-4">
    <div class="tw-text-lg tw-font-medium">
      {{
        tooMuchData
          ? I18n.t('components.templates.async_render_error.title')
          : I18n.t('common.error.try_again')
      }}
    </div>
    <div v-if="tooMuchData" class="tw-text-sm">
      {{ I18n.t('components.templates.async_render_error.description') }}
    </div>
  </div>
  <SfBannerPage
    :title="I18n.t('components.templates.async_render_error.banner.title')"
    variant="success"
    has-long-text
    is-full-width
    class="tw-mb-2"
  >
    <span
      v-dompurify-html="
        I18n.t(
          'components.templates.async_render_error.banner.description_html'
        )
      "
    />
  </SfBannerPage>

  <div
    v-if="tooMuchData && canBeDeleted"
    class="
      tw-flex
      tw-items-center
      tw-justify-between
      tw-mb-2
      tw-bg-sf-neutral-subtle-2
      tw-p-1
      tw-pl-2
      tw-rounded-lg
    "
  >
    <div>
      <span class="fa fa-solid fa-trash-can tw-mr-1"></span>
      <span>{{
        I18n.t('components.templates.async_render_error.delete_row.title')
      }}</span>
    </div>
    <SfButtonDs variant="secondary" size="sm" @click="handleClick">
      {{
        I18n.t(
          'components.templates.async_render_error.delete_row.button_label'
        )
      }}
    </SfButtonDs>
  </div>

  <div
    v-if="tooMuchData"
    class="
      tw-flex
      tw-items-center
      tw-justify-between
      tw-bg-sf-neutral-subtle-2
      tw-p-1
      tw-pl-2
      tw-rounded-lg
    "
  >
    <div>
      <span class="fa fa-solid fa-eye tw-mr-1"></span>
      <span>{{
        I18n.t('components.templates.async_render_error.review_row.title')
      }}</span>
    </div>
    <SfButtonDs variant="secondary" size="sm" @click="openUrl">
      {{
        I18n.t(
          'components.templates.async_render_error.review_row.button_label'
        )
      }}
    </SfButtonDs>
  </div>
</template>

<script setup lang="ts">
import type { AsyncRenderErrorReason } from './async-render-error.types'

import { computed } from 'vue'

import { SfButtonDs } from '@silverfin/ui-components'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { deleteReconciliationDetails } from '@app/application/reconciliation/utils'
import SfBannerPage from '@app/shared/vue/components/sf-banner/sf-banner-page.vue'

interface Props {
  reason?: AsyncRenderErrorReason
  canBeDeleted?: boolean
  reviewPath?: string
  url?: string
  message?: string
  confirmationName?: string
}

const {
  reason = 'too_much_data',
  canBeDeleted = false,
  reviewPath = '',
  url = '',
  message = '',
  confirmationName = '',
} = defineProps<Props>()

const I18n = useI18n()

// A template that failed to load its resources can neither be fixed by a
// delete of its data nor be read on the Review tab, which loads it the same way.
const tooMuchData = computed(() => reason === 'too_much_data')

function handleClick() {
  deleteReconciliationDetails(url, message, confirmationName)
}

function openUrl() {
  window.Turbolinks.visit(reviewPath)
}
</script>
